export default /*@ngInject*/ function ($scope, RequestManagementSAPService) {

    $scope.addCompositeRoleToList = function (compositeRole, productName) {
        $scope.vm.ListOfAvailableSAPCompositeRoles[productName].forEach(function (row, i) {
            if (row.Id === compositeRole.Id) {
                $scope.vm.ListOfAvailableSAPCompositeRoles[productName].splice(i, 1);
                $scope.vm.ListOfSelectedSAPCompositeRoles[productName].push(row);
            }
        });
        setChildrenHidden(compositeRole, productName, false);
        $scope.vm.IsRisksReviewed = null;
    };

    $scope.deleteSelectedCompositeRole = function (compositeRole, productName) {
        $scope.vm.ListOfSelectedSAPCompositeRoles[productName].forEach(function (row, i) {
            if (row.Id === compositeRole.Id) {
                $scope.vm.ListOfSelectedSAPCompositeRoles[productName].splice(i, 1);
                if (compositeRole.IsAssignable) {
                    $scope.vm.ListOfAvailableSAPCompositeRoles[productName].push(row);
                }
                if (compositeRole.IsEmergencyAccess) {
                    // Clear out selected TCodes
                    $scope.vm.ListOfAvailableSAPRoleObjects[productName] = null;
                    $scope.vm.ListOfSelectedSAPRoleObjects[productName] = null;
                }
            }
        });
        setChildrenHidden(compositeRole, productName, true);
        $scope.vm.IsRisksReviewed = null;
    };

    function setChildrenHidden(compositeRole, productName, hidden) {
        var app = ($scope.vm.availableApplications || []).find(function (a) { return a.ProductName === productName; });
        if (!app || !compositeRole.Identifier) return;
        RequestManagementSAPService.getRolesByCompositeRole({
            ProductId: app.ProductID,
            CompositeRoleIds: [compositeRole.Identifier]
        }).then(function (response) {
            if (!response || !response.data) return;
            var selected = $scope.vm.ListOfSelectedSAPSingleRoles[productName] || [];
            response.data.forEach(function (child) {
                var match = selected.find(function (sr) { return sr.Identifier === child.RoleIdentifier; });
                if (match && match.IndirectlyAssigned) {
                    match._hiddenByRevokedComposite = hidden;
                }
            });
        });
    }
}